import React from "react";
import PropTypes from "prop-types";
import "./index.less";

const ContactCard = props => {
  const { title, username, phone, avatar, datas } = props;
  return (
    <div className="weax-iconblock-contactcard">
      <div className="weax-iconblock-contactcard-north">
        <div className="weax-iconblock-contactcard-north-info">
          <h2 className="weax-iconblock-contactcard-north-title">
            {title}
          </h2>
          <div className="weax-iconblock-contactcard-north-contact">
            <h3 className="weax-iconblock-contactcard-north-people">{username}</h3>
            <h3 className="weax-iconblock-contactcard-north-number">{phone}</h3>
          </div>
        </div>
        <div className="weax-iconblock-contactcard-north-avatar">
          <img
            className="weax-iconblock-contactcard-north-avatar-img"
            src={avatar}
          />
        </div>
      </div>
      <div className="weax-iconblock-contactcard-south">
        {
          datas.map((data, index) => (
            <div className="weax-iconblock-contactcard-south-item" key={index}>
              <h4 className="weax-iconblock-contactcard-south-item-value">{data.value}</h4>
              <p className="weax-iconblock-contactcard-south-item-name">{data.name}</p>
            </div>
          ))
        }
      </div>
    </div>
  );
};

ContactCard.defaultProps = {
  template: 'temp1',
  title: "上海维森集团股份有限公司",
  username: "吴学清",
  phone: 15026579654,
  avatar: "https://jdc.jd.com/img/200",
  datas: [
    { name: "准入日期", value: "2019-04-15" },
    { name: "订单数量", value: 12 },
    { name: "整改通知", value: 0 },
  ]
};

ContactCard.propTypes = {
  template: PropTypes.oneOf(['temp1', 'temp2']),
  title: PropTypes.string,
  username: PropTypes.string,
  phone: PropTypes.number,
  avatar: PropTypes.string,
  datas: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }))
};

export default ContactCard;
